import * as UAParserLib from 'ua-parser-js'

/*import   UAParser   ,
       { IResult    }  from 'ua-parser-js';*/

import { store      }  from '../store/store';

interface ScreenInfo {
  width: number;
  height: number;
}

export interface ExtendedResult extends UAParserLib.IResult {

  screen:   ScreenInfo;
  referrer: string;
}

export const getUserAgentInformations = (): string => {

  const userAgentInformationsFromStore = store.getState().clientReducer.client.userAgentInformations;

  let userAgentInformations = "";

  if ( true ) //userAgentInformationsFromStore === "" )
        {
         userAgentInformations = JSON.stringify ( retrieveUserAgentInformations() );

         store.dispatch ( { type:                     'SET_UAINFOS'         ,
							newUserAgentInformations: userAgentInformations } );
        }
   else {
         userAgentInformations = userAgentInformationsFromStore;
        }

  return userAgentInformations;
}

export const retrieveUserAgentInformations = (): ExtendedResult => {

    const parser = new UAParserLib.UAParser()  // new UAParser();

    const parserResults = parser.getResult();


    let extendedResults: ExtendedResult = {

       ...parserResults,
       screen: {
          width: window.screen.width,
          height: window.screen.height,
       },
	   referrer: document.referrer
    };

	return extendedResults;
}
